const data = {
  multiLink: {
    img: import("../../images/multilink-screely.png"),
    title: "Multilink",
    techUsed: "MongoDB, ExpressJS, ReactJS, NodeJS (MERN)",
    siteLink: "https://multilinkapp.netlify.app/",
    githubLink: "",
    Description:
      "If you have used or heared of linktree website then you might know what it does. It's my first MERN stack app. I created this to learn about MERN like how to use mongodb with nodejs & expressjs.",
  },
  passGen: {
    img: import("../../images/Pass-Screely.png"),
    title: "Password Generator App",
    techUsed: "Ionic 5, ReactJS, JavaScript",
    siteLink: "https://github.com/Y1a2s3h4/password-generator-ionic",
    githubLink: "https://github.com/Y1a2s3h4/password-generator-ionic",
    Description:
      "This is a small app which i created with Ionic. It generates the password and the length is given by user.",
  },
  CovidApp: {
    img: import("../../images/CovidApp-Screely.png"),
    title: "Covid-19 Cases Tracker App",
    techUsed: "Ionic 5, ReactJS, TypeScript",
    siteLink: "https://github.com/Y1a2s3h4/ionic-react",
    githubLink: "https://github.com/Y1a2s3h4/ionic-react",
    Description:
      "It was my first app created with Ionic. Because i love to use APIs after learning the basics of Ionic I thought how we can use APIs with typescript this helped me to understand typescript.",
  },
  FindGH: {
    img: import("../../images/Find-GH-Screely.png"),
    title: "Find GitHub Web App",
    techUsed: "HTML, CSS, JavaScript, API",
    siteLink: "https://findgithub.firebaseapp.com/",
    githubLink: "https://github.com/Y1a2s3h4/FindGithub",
    Description:
      "This web app uses GitHub API. It gives the information of the github user. It gives multiple information like users Profile picture, Number of repositories, List of users public repositories with ability to download that repository and to vist that respository if it's hosted on gh-pages",
  },
  MediaFlix: {
    img: import("../../images/Media-Screely.png"),
    title: "MediaFlix Web App",
    techUsed: "ReactJS, Bootstrap, API",
    siteLink: "https://media-flix.netlify.app/",
    githubLink: "https://github.com/Y1a2s3h4/media-flix",
    Description:
      "This web gives the movies, tvshows, & webseries information like Release-Date, Original Language of the movie, tvshow or series. Ratings, & Plot of it. This web app was my final year project in college.",
  },
  CovidWeb: {
    img: import("../../images/TrackCorona-Screely.png"),
    title: "Covid-19 Cases Tracker Web App",
    techUsed: "HTML, CSS, JavaScript, API",
    siteLink: "https://track-corona.firebaseapp.com/",
    githubLink: "https://github.com/Y1a2s3h4/Track-Coronavirus",
    Description:
      "In the start of pandemic I was searching for a site or web app which could give the information about not only on the world and other countries but a detailed information for India. So i searched many sites for API with this kind of information and got one and they made their API public. So i decided to create it. And insted of using reactjs this time for a bit change i created this with vanillajs.",
  },
  VehicleRegInfo: {
    img: import("../../images/Vehicle-Reg-Screely.png"),
    title: "Vehicle Registration Information",
    techUsed:
      "ReactJS, NodeJS, ExpressJS, CheerioJS(WebScraping) & Puppeteer(WebAutomation)",
    siteLink: "https://vehicle-reg-info.netlify.app/",
    githubLink: "https://github.com/Y1a2s3h4/Vehicle-Reg-Details",
    Description:
      "I created this web app just to learn about web scraping and web automation and this was the best to improve the understanding of webscrping and webautomation.",
  },
  ChatApp: {
    img: import("../../images/Chat App.png"),
    title: "Chat App Design In Adobe XD",
    techUsed: "Adobe XD",
    siteLink:
      "https://xd.adobe.com/view/74103bba-d1c4-4a4a-487d-e3b9cb87dfe0-0221/",
    githubLink: "",
    Description:
      "I created this design in XD. Learn how to use multiple color properly in one design. I used 60-30-10 technique to apply all colors properly where one color is base color and mostly used around 60% then a secondary color which is used 30% and the last 10% which is used for minor details.",
  },
  pepperFry: {
    img: import("../../images/pepperfryApp.png"),
    title: "Pepperfry App Design In Adobe XD",
    techUsed: "Adobe XD",
    siteLink:
      "https://xd.adobe.com/view/941fa5c2-680e-4ffd-632a-296dfb3b0583-e22e/",
    githubLink: "",
    Description:
      "I saw ui and i loved it so i thought to create it with my design thinking.",
  },
  todoApp: {
    img: import("../../images/todoAppDesign.png"),
    title: "Todo App Design In Adobe XD",
    techUsed: "Adobe XD",
    siteLink:
      "https://xd.adobe.com/view/ba0a6550-db65-4331-7328-31435b88efd9-cc3b/",
    githubLink: "",
    Description:
      "I saw so many todo app design inspirations and thought to create my own.",
  },
  AmongUs: {
    img: import("../../images/AmongUs_Thumbnail.png"),
    title: "Amongus Thumbnail",
    techUsed: "Adobe Photoshop",
    siteLink: "",
    githubLink: "",
    Description:
      "Amongus was in trend and now youtubers will need thumbnails so thought to create a thumbnail. An this thumbnail was used a gamer who won streamer of the year 2018 by RakaZone Gaming.",
  },
  CODM: {
    img: import("../../images/CODM_THUMBNAIL_5.png"),
    title: "Call Of Duty Mobile Thumbnail",
    techUsed: "Adobe Photoshop",
    siteLink: "",
    githubLink: "",
    Description:
      "I love to play CODM and for a gaming enthusiast Call Of Duty fanchise is favourite, So tried to create a thumbnail.",
  },
  Valorant1: {
    img: import("../../images/Valorant_4.png"),
    title: "Valorant Thumbnail",
    techUsed: "Adobe Photoshop",
    siteLink: "",
    githubLink: "",
    Description:
      "Valorant is a multiplayer tactical first-person shooter i haven't played it yet because of my low-spec pc. I have played CS:GO which is similar to valorant. But not exactly similar because valorant has range of agents(varity of characters) with different different abilities. So thought to create a thumbnail.",
  },
  Valorant2: {
    img: import("../../images/VALORANT_THUMBNAIL.png"),
    title: "Valorant Thumbnail",
    techUsed: "Adobe Photoshop",
    siteLink: "",
    githubLink: "",
    Description:
      "Valorant is a multiplayer tactical first-person shooter i haven't played it yet because of my low-spec pc. I have played CS:GO which is similar to valorant. But not exactly similar because valorant has range of agents(varity of characters) with different different abilities. So thought to create a thumbnail.",
  },
};
export default data;
